import { BOTTOM_NAV_HEIGHT } from "@elyxeer/ui";

/**
 * MUI anchors a Snackbar 8px from the bottom, which on a phone puts it underneath the
 * fixed tab bar. Lift it clear of both the bar and the home indicator.
 */
export const SNACKBAR_POSITION = {
  bottom: {
    xs: `calc(${BOTTOM_NAV_HEIGHT + 16}px + env(safe-area-inset-bottom))`,
    md: 24,
  },
} as const;

/**
 * The same idea mirrored upward: on a phone this toast appears at the top of the
 * screen, clear of the notch; a desktop window keeps the conventional bottom corner.
 */
export const SNACKBAR_POSITION_TOP = {
  top: { xs: "calc(env(safe-area-inset-top) + 16px)", md: "auto" },
  bottom: { xs: "auto", md: 24 },
} as const;
